export const MODULE_NAME = 'menu'

export const BREADCRUMB_STORE_ID = `${MODULE_NAME}/breadcrumb`
